var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ErrorCodes, ExceptionHandlerClass } from '../System/Aop';
var Model = (function () {
    function Model(uniqueId, obj) {
        if (uniqueId === void 0) { uniqueId = ''; }
        if (obj === void 0) { obj = null; }
        this.myInternalProperties = ['_internalProperties', 'events',
            'EventChanges', 'childrenToNotify', 'onModelChange', '_isTempModel', '_pointers'];
        this.___setInitialValues(uniqueId, obj);
    }
    Model_1 = Model;
    Model.prototype.notifiercount = function () {
        return this.childrenToNotify.length;
    };
    Object.defineProperty(Model.prototype, "UniqueID", {
        get: function () {
            return this.myUniqueID;
        },
        set: function (value) {
            this.myUniqueID = value;
            this.childrenToNotify.forEach(function (c) { return c.__notify('UniqueID', value); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "IsTempModel", {
        get: function () {
            return this.myIsTempModel;
        },
        set: function (value) {
            this.myIsTempModel = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "IsModalView", {
        get: function () {
            return this.myIsModalView;
        },
        set: function (value) {
            this.myIsModalView = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "isPointer", {
        get: function () {
            return this['@k'] === 2 && (this['p'] || this['v']);
        },
        enumerable: false,
        configurable: true
    });
    Model.prototype.__notify = function (property, value) {
        if (property === 'UniqueID') {
            this.UniqueID = this.uniqueName() + Model_1.separator + value;
        }
        else {
            this[property] = value;
        }
    };
    Model.prototype.__subscribe = function (model) {
        this.childrenToNotify.push(model);
    };
    Model.prototype.addReference = function (property, item) {
        if (this.isArray) {
            this.addOnArray(this, item);
        }
        else {
            this[property] = item;
        }
        this.fireChange();
    };
    Model.prototype.addValue = function (property, value) {
        this[property] = value;
        this.fireChange();
    };
    Model.prototype.uniqueName = function () {
        var name = this.UniqueID.split(Model_1.separator)[0];
        return name === '_items' ? 'Items' : name;
    };
    Model.prototype.parentName = function () {
        return this.UniqueID.substr(this.UniqueID.indexOf(Model_1.separator) + Model_1.separator.length);
    };
    Model.prototype.isRoot = function () {
        return this.UniqueID.indexOf(Model_1.separator) === -1;
    };
    Model.prototype.parentNameKey = function (key) {
        return key.substr(key.indexOf(Model_1.separator) + 1);
    };
    Model.prototype.isCoreSynchronizing = function () {
        return false;
    };
    Model.prototype.updateModel = function (item) {
        var _this = this;
        this.applyOnProperties(item, function (prop) {
            if (_this[prop] !== item[prop]) {
                var oldValue = _this[prop];
                _this[prop] = item[prop];
                if (_this.onPropertyChange != null) {
                    _this.onPropertyChange(prop, oldValue, _this[prop]);
                }
            }
        });
        this.fireChange();
    };
    Model.prototype.applyOnProperties = function (item, fn) {
        for (var prop in item) {
            if (item.hasOwnProperty(prop) && this.myInternalProperties.indexOf(prop) === -1) {
                fn.call(this, prop);
            }
        }
    };
    Model.prototype.removeModel = function (item) {
        var removed = false;
        if (this.isArray) {
            removed = this.removeOnArray(item);
        }
        else {
            if (this[item.uniqueName()]) {
                delete this[item.uniqueName()];
                removed = true;
            }
        }
        if (removed) {
            var itemIndex = this.childrenToNotify.indexOf(item);
            if (itemIndex > -1) {
                this.childrenToNotify.splice(itemIndex, 1);
            }
            this.fireChange();
        }
    };
    Model.prototype.fireChange = function () {
        if (this.onModelChange) {
            this.onModelChange();
        }
    };
    Model.prototype.applyMethod = function (method) {
        if (this[method]) {
            this[method]();
        }
    };
    Model.prototype.hasCircularReference = function () {
        if (!this.isArray) {
            return false;
        }
        var observable = this;
        for (var _i = 0, observable_1 = observable; _i < observable_1.length; _i++) {
            var obs = observable_1[_i];
            var isCircularReference = this.UniqueID.indexOf(obs.UniqueID) > 0;
            if (isCircularReference) {
                return true;
            }
        }
        return false;
    };
    Model.prototype.addPointerId = function (key, pointerId) {
        this.myPointers[key] = pointerId;
    };
    Model.prototype.getPos = function (key) {
        var name;
        if (key && this.getPointerId(key)) {
            name = this.getPointerName(key);
        }
        else {
            name = this.uniqueName();
        }
        return name.match(/^\d+$/) ? Number(name) : -1;
    };
    Object.defineProperty(Model.prototype, "isArray", {
        get: function () {
            return this['@arr'];
        },
        enumerable: false,
        configurable: true
    });
    Model.prototype.addValueArray = function (array, item, i) {
        if (array[i] !== undefined) {
            array[i] = item;
        }
        else {
            array.push(item);
        }
    };
    Model.prototype.removeValueAray = function (array, start, count) {
        array.splice(start, count);
    };
    Model.prototype.addReferencedBy = function (modelId, name) {
        throw new Error('WebMap 5 function not implemented in WebMap 4');
    };
    Model.prototype.removeReference = function (name) {
        throw new Error('WebMap 5 function not implemented in WebMap 4');
    };
    Model.prototype.___setInitialValues = function (uniqueId, obj) {
        if (obj === void 0) { obj = null; }
        this.myUniqueID = uniqueId;
        this.myIsTempModel = false;
        this.myIsModalView = false;
        this.myPointers = {};
        this.addProperties(obj);
        this.events = {};
        if (obj && obj.EventChanges) {
            this.eventChanges = obj.EventChanges;
        }
        if (this.isArray) {
            this.addArrayMethods(this);
        }
        if (this.isPointer) {
            this.addPointerProperties(this);
        }
        this.childrenToNotify = new Array();
    };
    Model.prototype.addProperties = function (obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (key !== 'UniqueID') {
                    this[key] = obj[key];
                }
            }
        }
    };
    Model.prototype.addOnArray = function (array, item) {
        array.splice(item.getPos(this.UniqueID), 0, item);
    };
    Model.prototype.addArrayMethods = function (array) {
        this.addSpliceMethod(array);
        this.addPushMethod(array);
        this.addSortMethod(array);
        this.myInternalProperties.push('length');
    };
    Model.prototype.addSpliceMethod = function (array) {
        if (!array.splice) {
            Array.prototype.splice.apply(array);
            array.splice = Array.prototype.splice;
        }
    };
    Model.prototype.addPushMethod = function (array) {
        if (!array.push) {
            Array.prototype.push.apply(array);
            array.push = Array.prototype.push;
        }
    };
    Model.prototype.addSortMethod = function (array) {
        if (!array.sort) {
            Array.prototype.sort.apply(array);
            array.sort = Array.prototype.sort;
        }
    };
    Model.prototype.removeOnArray = function (item) {
        var removed = false;
        var array = this;
        if (item.getPos(this.UniqueID) > -1 && array[item.getPos(this.UniqueID)] &&
            item.UniqueID === array[item.getPos(this.UniqueID)].UniqueID) {
            array.splice(item.getPos(this.UniqueID), 1);
            removed = true;
        }
        else {
            var itemIndex = this.getPositionOnArray(item);
            if (itemIndex > -1) {
                array.splice(this.getPositionOnArray(item), 1);
                removed = true;
            }
        }
        return removed;
    };
    Model.prototype.getPositionOnArray = function (item) {
        var array = this;
        var position = -1;
        for (var i = 0; i < array.length; i++) {
            if (item.UniqueID === array[i].UniqueID) {
                position = i;
                break;
            }
        }
        return position;
    };
    Model.prototype.addPointerProperties = function (model) {
        if (model.p) {
            model._uniqueID = model.p[0].replace('->', '');
            model.myUniqueID = model.p[0].replace('->', '');
            model.p = model.p[1];
        }
        else if (model.v) {
            model._uniqueID = model.v[0].replace('->', '');
            model.myUniqueID = model.p[0].replace('->', '');
            model.v = model.v[1];
        }
    };
    Model.prototype.getPointerId = function (key) {
        return this.myPointers[key];
    };
    Model.prototype.getPointerName = function (key) {
        var pointerName = this.getPointerId(key);
        if (pointerName) {
            var name_1 = pointerName.split(Model_1.separator)[0];
            return name_1 === '_items' ? 'Items' : name_1;
        }
        else {
            return undefined;
        }
    };
    var Model_1;
    Model.separator = '#';
    Model.collectionItemPrefix = 'KI';
    Model = Model_1 = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore),
        __metadata("design:paramtypes", [Object, Object])
    ], Model);
    return Model;
}());
export { Model };
